import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import { auth } from './firebase' // ✅ Firebase Auth instance
import * as firebaseAuth from 'firebase/auth' // ✅ Firebase Auth module

Vue.config.productionTip = false

// ✅ Attach Firebase Auth to window for debugging (optional)
window.firebase = firebaseAuth
window.firebaseAuth = auth

// ✅ Wait for Firebase Auth to initialize before mounting the app
let app

auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})